<script>
export default {
  props: {
    autoStartAnimation: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      time: 0,
    };
  },
  methods: {
    startAnimation() {
      const animationID = ++this._animationID;
      this._animationStart = +new Date();
      this._tickTime = this._animationStart;
      requestAnimationFrame(() => this._tick(animationID));
    },
    stopAnimation() {
      ++this._animationID;
    },
    _tick(animationID) {
      if (this._animationID != animationID) return;

      const lastTick = this._tickTime;
      this._tickTime = +new Date();
      this.time = this._tickTime - this._animationStart;
      this.$emit(
        "tick",
        this._tickTime - lastTick,
        this._tickTime - this._animationStart
      );

      requestAnimationFrame(() => this._tick(animationID));
    },
  },
  created() {
    this._animationID = 0;
  },
  mounted() {
    if (this.autoStartAnimation) this.startAnimation();
  },

  destroyed() {
    this.stopAnimation();
  },
};
</script>